import { httpPost } from "../../../setup/axios/axiosUtils";
import { getUserTokenFromLocal } from "../../pages/Home/Components/Popups/CartPages/utils";
import { useState } from "react";
import { URL_CONSTANTS } from "../urlsLink";
import { IACTIVESUBPLAN, SUBSPALNLIST } from "../../shared/interfaces";
import { useParams } from "react-router-dom";
import { getCustomerInfoFromStroge } from "../../pages/Home/utils";
import useBussinessPage from "../useBussiness";
const useSubsPlan = () => {
  const { bussinessName } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    isError: false,
    errorMessage: "",
  });

  const [subsPlanList, setSubPlanList] = useState<SUBSPALNLIST[]>([]);
  const [subsActivePlan, setActivePlan] = useState<IACTIVESUBPLAN>();
  const [accessToken, setAccessToken] = useState(
    getUserTokenFromLocal(bussinessName!)
  );
  const availSubsPlan = async (plan_id: string, gateWay: string) => {
    var customerFromStrg = getCustomerInfoFromStroge();
    setLoading(true);
    var success = false;
    var finalData = {
      plan_id,
      customer_id: customerFromStrg.id,
      customer_name: customerFromStrg.name,
      customer_mobile: customerFromStrg.mobile_number,
      billingGateway: gateWay,
    };
    try {
      const res = await httpPost(
        `${URL_CONSTANTS.get("URL_Get_SUB_AVAIL_PLAN")}`,
        finalData,
        {},
        accessToken
      );
      if (res.type === "success") {
        setLoading(false);
        success = true;
        return { success, res };
      } else {
        setError({
          isError: true,
          errorMessage: res.message,
        });
        setLoading(false);
        success = false;
        return success;
      }
    } catch (error: any) {
      setLoading(false);
      console.log(error.message);
      setError({
        isError: true,
        errorMessage: error.message,
      });
    }
  };
  const getActiveSub = async (customer_id: string) => {
    setLoading(true);

    var success = false;
    try {
      const res = await httpPost(
        `${URL_CONSTANTS.get("URL_Get_ACTIVE_PLAN")}`,
        { customer_id },
        {},
        accessToken
      );
      // if (res.token === "expired") {
      //   getUserToken(bussinessName!).then((token) => {
      //     setAccessToken(token);
      //     // getActiveSub(customer_id);
      //   });
      //   return;
      // }
      if (res.type === "success") {
        setLoading(false);
        success = true;
        var response = res;
        setActivePlan(res.data);
        return { success, res };
      } else {
        setLoading(false);
        success = false;
        return success;
      }
    } catch (error: any) {
      setLoading(false);
      console.log(error.message);
    }
  };
  const getSubList = async () => {
    setLoading(true);
    var success = false;
    try {
      const res = await httpPost(
        `${URL_CONSTANTS.get("URL_Get_SUB_PLAN")}`,
        {},
        {},
        accessToken
      );
      // if (res.token === "expired") {
      //   getUserToken(bussinessName!).then((token) => {
      //     setAccessToken(token);
      //     // getSubList();
      //   });
      //   return;
      // }
      if (res.type === "success") {
        setLoading(false);
        success = true;
        var response = res;
        setSubPlanList(res.data.subscription_plans);
        return { success, res };
      } else {
        setLoading(false);
        success = false;
        return success;
      }
    } catch (error: any) {
      setLoading(false);
      console.log(error.message);
    }
  };
  return {
    getActiveSub,
    getSubList,
    availSubsPlan,
    loading,
    planApiError: error,
    subsPlanList,
    subsActivePlan,
  };
};

export default useSubsPlan;
